import { useSelector } from "react-redux";
import { RootState } from "../store";

const useIsRadiographer = (): boolean => {
  const userGroups = useSelector((state: RootState) => state?.userContext?.userCreds?.userGroups);
  return (userGroups || []).some((ug) => ug.toLowerCase() === "radiographer");
};

export default useIsRadiographer;
